import React from "react";
import * as validate from "../../../Components/Modals/validations";
import * as cuBuilding from "../building_pricing/pricingReducer";
import * as cuComponent from "../building_component/componentReducer";
import { handleMobileThumbView, prepareQuotePostData, resetBuildingView, resetCameraPosition } from "../../../helpers/quote_order/quote.helper";
import { const_var,params } from "../reducer";

export const quoteState = {
	checkquoteValidateonly: "",
	createLeadOnly: false,
	saveLatterModal: false,
	orderLaterSubmitBtn: false,
	displayerrorMessage: "",
	i_g_A_y: [],
	crmSetting: {},
	thankYouForSaveLater: false,
	enableFinanceRTO: false,
	pdfURL: "",
	isShowAlert: false,
	alertUsedMSG: "",
	building_Data: "",
	showStateOnly: false,
	preQuoteError: false,
	preQuoteApiCalled: false,
	post_data: {},
	stopLoader: false
};
quoteState.displayerrorMessage = const_var.displayerrorMessage;
quoteState.crmSetting = const_var.crmSetting;
quoteState.hide_price_calculation = const_var.hide_price_calculation;
quoteState.loginSession = const_var.loginSession;
quoteState.enableFinanceRTO = false;
quoteState.stopLoader = false;

const quoteReducer = (state = quoteState, action) => {
	const newState = { ...state };
	switch (action.type) {
		case "keenBuildingRTO":
			state.enableFinanceRTO = action.val;
			return {
				...state,
				checkRTO: action.val
			};
		case "addLeadDetails":
			state.alertUsedMSG = "";
			state.saveLatterModal = true;
			const_var.saveLatterModal = true;
			state.createLeadOnly = true;
			const_var.createLeadOnly = true;
			const_var.displayerrorMessage = {
				email: "",
				first_name: "",
				last_name: "",
				phone_no: "",
				shipping_address_line_1: "",
				zipcode: ""
			};
			state.displayerrorMessage = const_var.displayerrorMessage;

			return {
				...state
			};
		case "handleSaveLatter":
			const_var.focusedSection = "";
			state.hide_price_calculation = const_var.hide_price_calculation;
			if (action.payload == "open") {
				if (const_var?.crmSetting?.applyPriceCheck == true && const_var?.BuildingPriceArrar["order_total"] && parseFloat(const_var.BuildingPriceArrar["order_total"].toFixed(2)) < parseFloat(3000)) {
					state.thankYouForSaveLater = true;
					state.alertUsedMSG = "Sorry, we are not accepting orders below $3000 (plus tax) currently. Please contact us for your requirements at - " + const_var.crmSetting.phone_number;
				} else {
					state.preQuoteApiCalled = const_var.preQuoteApiCalled;
					state.preQuoteError = const_var.preQuoteError;
					state.post_data = const_var.post_data;
					state.showStateOnly = const_var.showStateOnly;
					state.displayerrorMessage = const_var.displayerrorMessage;
					state.thankYouForSaveLater = false;
					state.building_Data = const_var.post_data.building;
					state.alertUsedMSG = "";
					const_var.checkIval = 0;
					state.i_g_A_y = [];
					const_var.i_g_A_y = [];
					const_var.checkCaptuareImage = false;
					state.saveLatterModal = true;
					const_var.saveLatterModal = true;
					const_var.selectedTabKeyForWheel = "capture";
					// cuComponent.removeDoorWindowsIcons();
					resetBuildingView();
					resetCameraPosition();
					handleMobileThumbView();
					state.i_g_A_y = const_var.i_g_A_y;
				}
				// const_var.proceedToMobileSave = const_var.isMobileDraw ? true : false;
			} else {
				if (const_var.i_g_A_y.length == 0) {
					const_var.checkCaptuareImage = false;
				}
				state.thankYouForSaveLater = false;
				state.alertUsedMSG = "";
				state.saveLatterModal = false;
				const_var.saveLatterModal = false;
				const_var.displayerrorMessage = {};
				state.enableFinanceRTO = false;
				state.stopLoader = false;
				const_var.proceedToMobileSave = false;
				const_var.leadCreatedSuccessfully = false;
				const_var.createLeadOnly = false;
				state.createLeadOnly = false;
				state.orderLaterSubmitBtn = false;
				const_var.pdfURL = "";
				state.pdfURL = "";
				const_var.displayerrorMessage = {
					email: "",
					first_name: "",
					last_name: "",
					phone_no: "",
					shipping_address_line_1: "",
					zipcode: ""
				};
				state.displayerrorMessage = const_var.displayerrorMessage;
			}
			return {
				...state,
				checkquoteValidateonly: action
			};
		case "handleSavePublicQuote":
			const_var.focusedSection = "";
			resetBuildingView();
			resetCameraPosition();

			state.displayerrorMessage = const_var.displayerrorMessage;
			state.thankYouForSaveLater = false;
			state.building_Data = const_var.post_data.building;
			state.alertUsedMSG = "";
			const_var.checkIval = 0;
			state.i_g_A_y = [];
			const_var.i_g_A_y = [];
			const_var.checkCaptuareImage = false;
			state.saveLatterModal = true;
			const_var.selectedTabKeyForWheel = "capture";
			// cuComponent.removeDoorWindowsIcons();
			handleMobileThumbView();
			state.i_g_A_y = const_var.i_g_A_y;
			return {
				...state,
				action
			};
			break;
		case "onquoteTextFiledChangeValue":
			state.stopLoader = true;
			validate.onTextFiledChangeValue(action.event, action.value, action.keyword);
			// if(action.updateVar == true && const_var.checkValidate == false){
			if (action.updateVar == true) {
				if (action.value == "zipcode") {
					const_var.zipCode = action.event.target ? action.event.target.value : action.event;
					const_var.post_data["billing_zipcode"] = action.event.target ? action.event.target.value : action.event;
				} else if (action.value == "shipping_address_line_1") {
					const_var.post_data["billing_address_line_1"] = action.event.target.value;
				} else {
					const_var.post_data[action.value] = action.event.target.value;
				}
			}
			return {
				...state,
				checkquoteValidateonly: action
			};
		case "onQuoteSubmit":
			if (const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false && const_var.showStateOnly != true) {
				if (const_var.checkValidate == false) {
					delete const_var.post_data["billing_address_line_1"];
					delete const_var.post_data["billing_zipcode"];
					const leanto = const_var?.post_data["building"]?.leanto;
					if (leanto && leanto.length > 0) {
						if (leanto.length > 1) {
							leanto[0].alignment = leanto[0].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
							leanto[1].alignment = leanto[1].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
						} else {
							leanto[0].alignment = leanto[0].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
						}
					}
					prepareQuotePostData();
					state.orderLaterSubmitBtn = true;
				}
				return {
					...state,
					checkquoteValidateonly: action.event
				};
			} else {
				validate.onSubmitForm(action.event);
				action.event.preventDefault();
				var result = {};
				if (const_var.checkValidate == false) {
					var newAddress = [];
					for (let i = 0; i <= action.event.target.length - 1; i++) {
						var arr = [{ key: action.event.target[i].name, value: action.event.target[i].value }];
						if (arr[0].key == "zipcode") {
							const_var.post_data["billing_zipcode"] = arr[0].value;
						} else if (arr[0].key == "phone_no") {
							const_var.post_data["mobile_no"] = arr[0].value;
							const_var.post_data["phone_no"] = arr[0].value;
						} else if (arr[0].key == "shipping_address_line_1") {
							const_var.post_data["billing_address_line_1"] = arr[0].value;
						} else {
							const_var.post_data[arr[0].key] = arr[0].value;
						}
					}
					newAddress.push({
						address_line_1: const_var.post_data["billing_address_line_1"],
						address_line_2: "",
						zipcode: const_var.post_data["billing_zipcode"],
						county: "",
						state: "",
						city: "",
						is_billing: 1,
						is_installation: 1
					});
					const_var.post_data["address"] = newAddress;
					delete const_var.post_data["billing_address_line_1"];
					delete const_var.post_data["billing_zipcode"];
					const { crmSetting, loginSession } = const_var;
					const preQuote = crmSetting?.pre_quote_form;
					if (
						const_var.isKLinkEnable == true ||
						!preQuote ||
						const_var.showStateOnly ||
						(preQuote == true && loginSession == true) ||
						(preQuote && !loginSession && (const_var.preQuoteError == true || (const_var.preQuoteApiCalled == false && const_var.showStateField == true)))
					) {
						const leanto = const_var?.post_data["building"]?.leanto;
						if (leanto.length > 0) {
							if (leanto.length > 1) {
								leanto[0].alignment = leanto[0].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
								leanto[1].alignment = leanto[1].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
							} else {
								leanto[0].alignment = leanto[0].leanto_type == 1 ? const_var.TypeAlingnment[params.leantoAlignmentLeft] : const_var.TypeAlingnment[params.leantoAlignmentRight];
							}
						}
						prepareQuotePostData();
						if (const_var.post_data?.sensei_sales_id) {
							const_var.post_data["lead_source"] = "Sensei Sales Id";
						}
						state.orderLaterSubmitBtn = true;
					}
				}
				return {
					...state,
					checkquoteValidateonly: action.event
				};
			}
		case "onQuoteSubmitApi":
			if (action.event.status == true) {
				if (const_var.crmSetting.gTag == true) {
					window.analysisCode();
				}
				const_var.checkoutBtnDisabled = false;
				state.orderLaterSubmitBtn = false;
				const_var.pdfURL = action.event.pdf_url;
				state.pdfURL = action.event.pdf_url;
				state.saveLatterModal = false;
				const_var.saveLatterModal = false;
				state.thankYouForSaveLater = true;
				state.stopLoader = false;
				const_var.estimator_QuestionAnswer = const_var.estimator_DefaultQuestionAnswer;
				const sub_order_total_keen = const_var.BuildingPriceArrar?.sub_order_total ?? 0;
				if (state.enableFinanceRTO && const_var.crmSetting.main_domain_url == "keensbuildings.com") {
					window.location.href = `https://keensbuildings.com/metal-building-financing-rto-application?subtotal=${sub_order_total_keen}&quote_id=${action.event.quote_string}`;
					state.enableFinanceRTO = false;
				}
			} else {
				let responseMessage = action.event.message;
				responseMessage = responseMessage.replace("[PhoneNumber]", const_var.crmSetting.phone_number);
				responseMessage = responseMessage.replace("[Email]", const_var.crmSetting.email);
				state.pdfURL = "";
				const_var.pdfURL = "";
				state.saveLatterModal = false;
				const_var.saveLatterModal = false;
				state.alertUsedMSG = responseMessage;
				const_var.checkoutBtnDisabled = false;
				state.orderLaterSubmitBtn = false;
				state.thankYouForSaveLater = true;
				state.enableFinanceRTO = false;
				state.stopLoader = false;
				const_var.estimator_QuestionAnswer = const_var.estimator_DefaultQuestionAnswer;
			}
			return {
				...state,
				checkquoteValidateonly: action.event + state.orderLaterSubmitBtn
			};
		case "setThankYouForSaveLaterValue":
			if (action.createLead && const_var.crmSetting.main_domain_url == "metalcarportdepotllc.com") {
				state.alertUsedMSG = "Your information has been successfully saved. Our team will proceed with further processing.";
				const_var.leadCreatedSuccessfully = true;
				state.saveLatterModal = false;
				const_var.saveLatterModal = false;
				const_var.createLeadOnly = true;
				state.createLeadOnly = true;
				state.orderLaterSubmitBtn = false;
			}
			state.thankYouForSaveLater = action.val;
			return {
				...state
			};
	}
	return newState;
};
export default quoteReducer;
